<!-- Log In page -->
<div class="row vh-100 ">
    <div class="col-12 align-self-center">
        <div class="auth-page">
            <div class="card auth-card shadow-lg">
                <div class="card-body">
                    <div class="px-3">
                        <div class="auth-logo-box">
                            <a href="/" class="logo logo-admin"><img src="./assets/images/logo-sm.png" height="55" alt="logo" class="auth-logo"></a>
                        </div><!--end auth-logo-box-->

                        <div class="text-center auth-logo-text">
                            <h4 class="mt-0 mb-3 mt-5" i18n>Password recovery</h4>
                            <p class="text-muted mb-0" i18n>Enter your email to recover your password.</p>
                        </div> <!--end auth-logo-text-->


                        <form class="form-horizontal auth-form my-4" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">

                            <div class="form-group">
                                <label for="email">Email</label>
                                <div class="input-group mb-3" [ngClass]="{ 'is-invalid': !f.email.untouched && f.email.errors }" >
                                    <span class="auth-form-icon">
                                        <fa-icon [icon]="faEnvelope"></fa-icon>
                                    </span>
                                    <input pInputText type="email" formControlName="email" email class="form-control" i18n-placeholder placeholder="Enter email">
                                </div>
                                <div *ngIf="f.email.errors" class="invalid-feedback">
                                    <div *ngIf="!f.email.untouched && f.email.errors.required" i18n>Email is required.</div>
                                </div>
                                <div class="invalid-feedback" *ngIf="f.email.value !== '' && !f.email.untouched && f.email.invalid" i18n>Please enter valid email.</div>
                            </div><!--end form-group-->


                            <div class="form-group mb-0 row">
                                <div class="col-12 mt-2 p-fluid">
                                    <button pButton pRipple type="submit" i18n-label label="Reset" [disabled]="forgotPasswordForm.invalid" [loading]="loading" class="p-button-rounded"></button>
                                </div><!--end col-->
                            </div> <!--end form-group-->
                        </form><!--end form-->
                    </div><!--end /div-->

                    <div class="m-3 text-center text-muted">
                        <p><span i18n>Did you just remembered?</span><a [routerLink]="['/auth', 'sign-in']" class="text-primary ml-2" i18n>Sign in here</a></p>
                    </div>
                </div><!--end card-body-->
            </div><!--end card-->
        </div><!--end auth-page-->
    </div><!--end col-->
</div><!--end row-->
<!-- End Log In page -->
